module.exports = __webpack_public_path__ + "static/media/bg5.a675d629.jpeg";